<template>
    <div>
        <div class="page-transition-wrap">
            <div class="css3-spinner">
                <div class="css3-spinner-bounce1"></div>
                <div class="css3-spinner-bounce2"></div>
                <div class="css3-spinner-bounce3"></div>
            </div>
        </div>
        <div :style="{margin: '2rem 15rem'}"></div>
    </div>
</template>
<script>
export default {
    computed: {

    },
}
</script>